import React, { Fragment } from 'react'
import { BioBlock } from 'component-library/content/BioBlock/BioBlock'
import { StyledMoreTitle } from 'component-library/content/Profile/Profile.styled'
import { Profile as ProfileData } from 'common/client-data-types/Profile'

export interface Props {
    profile: ProfileData
    profileUrl: string
}

export const SevenNewsProfile: React.FC<Props> = props => {
    return (
        <Fragment>
            <BioBlock profile={props.profile} url={props.profileUrl} title={props.profile.name} />
            <StyledMoreTitle>More from {props.profile.name}</StyledMoreTitle>
        </Fragment>
    )
}
